import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import TextField from '@material-ui/core/TextField'
import React from 'react'
import AnimateHeight from 'react-animate-height'
import { controlHasError } from '../../lib/errorHandler'
import ExpandablePanel from '../controls/ExpandablePanel'
import ButtonAddInfo from '../controls/ButtonAddInfo'
import ListItemMenu from '../controls/ListItemMenu'
import SkonsolidowanePolaczenieSpolekStyleV12 from '../../styles/SkonsolidowanePolaczenieSpolekStyleV12'
import PrintText from '../../lib/PrintText'

function SkonsolidowanePolaczenieSpolekV12({
  data,
  onSetSectionDataArray,
  sIndex,
  onSetSectionData,
  errors,
  onDeleteDetail,
  onAddDetailInfo,
  czyPodsumowanie,
}) {
  const struktura = {
    SporzadzonoPoPolaczeniu: true,
    OpisMetody: '',
  }

  function options(i) {
    return [{ title: 'USUŃ', action: () => handleDelete(i, sIndex) }]
  }

  function handleCheckbox(e) {
    if (data.Pozycje.length === 0) onAddDetailInfo(struktura, sIndex)
    onSetSectionData('CzyPolaczonoSpolki', e.target.checked, sIndex)
  }

  function handleDelete(i, sIndex) {
    if (data.Pozycje.length === 1)
      onSetSectionData('CzyPolaczonoSpolki', false, sIndex)
    onDeleteDetail(i, sIndex)
  }

  return (
    <SkonsolidowanePolaczenieSpolekStyleV12>
      <ExpandablePanel withoutBackground title="POŁĄCZENIE SPÓŁEK">
        <form autoComplete="off" className="polaczenie">
          <div className="checkbox">
            <FormControlLabel
              className="checkboxLabel high-caption"
              control={
                <Checkbox
                  name="CzyPolaczonoSpolki"
                  color="primary"
                  checked={data.CzyPolaczonoSpolki}
                  onChange={handleCheckbox}
                />
              }
              label="W okresie sprawozdawczym nastąpiło połączenie spółek"
            />
          </div>
          <AnimateHeight
            duration={250}
            height={data.CzyPolaczonoSpolki ? 'auto' : 0}
          >
            {data.Pozycje.length > 0
              ? data.Pozycje.map((element, index) => (
                  <div className="element" key={index}>
                    <div className="nazwaJednostki">
                      <TextField
                        className="text"
                        error={controlHasError(errors, 'Nazwa')}
                        name="Nazwa"
                        label="Nazwa (firma) i siedziba jednostki powiązanej"
                        title={element.Nazwa}
                        defaultValue={element.Nazwa}
                        onChange={(e) =>
                          onSetSectionDataArray(
                            e.target.value,
                            index,
                            sIndex,
                            'Nazwa',
                          )
                        }
                      />
                      <ListItemMenu options={options(index)} />
                    </div>
                    <div className="szczegolyPolaczenia">
                      <p>SZCZEGÓŁY POŁĄCZENIA</p>
                    </div>

                    <div className="radioGroup">
                      <RadioGroup
                        row
                        name="SporzadzonoPoPolaczeniu"
                        value={
                          element.SporzadzonoPoPolaczeniu ? 'true' : 'false'
                        }
                        onChange={(e) =>
                          onSetSectionDataArray(
                            e.target.value === 'true',
                            index,
                            sIndex,
                            'SporzadzonoPoPolaczeniu',
                          )
                        }
                      >
                        <FormControlLabel
                          value="true"
                          control={<Radio color="primary" />}
                          label="Sprawozdanie sporządzono PO połączeniu"
                        />
                        <FormControlLabel
                          value="false"
                          control={<Radio color="primary" />}
                          label="Sprawozdanie sporządzono PRZED połączeniem"
                        />
                      </RadioGroup>
                    </div>
                    <div className="metoda">
                      {czyPodsumowanie ? (
                        <PrintText
                          text={element.OpisMetody}
                        />
                      ) : (
                        <TextField
                          className="textArea"
                          error={controlHasError(
                            errors,
                            'OpisMetody',
                            element.OpisMetody,
                            true,
                          )}
                          name="OpisMetody"
                          label="Zastosowana metoda rozliczenia połączenia"
                          multiline
                          variant="outlined"
                          value={element.OpisMetody}
                          onChange={(e) =>
                            onSetSectionDataArray(
                              e.target.value,
                              index,
                              sIndex,
                              'OpisMetody',
                            )
                          }
                        />
                      )}{' '}
                    </div>
                  </div>
                ))
              : null}
            {data.Pozycje.length > 0 && (
              <ButtonAddInfo
                label="DODAJ KOLEJNĄ JEDNOSTKĘ"
                structure={struktura}
                sIndex={sIndex}
                variant="outlined"
              />
            )}
          </AnimateHeight>
        </form>
      </ExpandablePanel>
    </SkonsolidowanePolaczenieSpolekStyleV12>
  )
}

export default SkonsolidowanePolaczenieSpolekV12
